/* unplugin-vue-components disabled */import script from "./PropsAddModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PropsAddModal.vue?vue&type=script&setup=true&lang=ts"

import "./PropsAddModal.vue?vue&type=style&index=0&id=e3edf098&scoped=true&lang=less"
import "./PropsAddModal.vue?vue&type=style&index=1&id=e3edf098&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3edf098"]])

export default __exports__